import React, { Component } from 'react';
import PropTypes from 'prop-types';

import qs from 'qs';
import InfiniteFetchList from './InfiniteFetchList';

import CompanyCard from './CompanyCard';
import UserCard from './UserCard';
import DiscussionCard from './DiscussionCard';
import EventCard from './EventCard';
import PerkCard from './PerkCard';

import DiscussionCreator from './DiscussionCreator';

import Avatar from './Avatar';

export default class CommunityFeed extends Component {
  static propTypes = {
    currentCommunity: PropTypes.object.isRequired,
    feedUrl: PropTypes.string.isRequired,
    currentUser: PropTypes.object.isRequired,
    perPage: PropTypes.number,
  }

  static defaultProps = {
    perPage: 20,
  }

  constructor(props) {
    super(props);
  }

  renderItem = (item) => {
    const components = {
      CompanyCard,
      UserCard,
      DiscussionCard,
      EventCard,
      PerkCard,
    };

    const ItemCard = components[item.card_type];

    return <div key={`${item.card_type}-${item.url}`}><ItemCard {...item} key={item.url} useTimezone={this.props.currentUser.timezone} /></div>;
  }

  noResults = () => {
    return (
      <div className="u-warning">
        We have no {this.props.currentCommunity.name} activity to show you yet.
        <br />
        As things happen in the community, this space will show you what&apos;s new.
      </div>
    );
  };

  render() {
    return (
      <InfiniteFetchList
        key="feed-items"
        apiUrl={this.props.feedUrl}
        perPage={this.props.perPage}
        itemRenderer={this.renderItem}
        subscribeTo={{
          channel: 'FeedChannel',
          community_id: this.props.currentCommunity.id,
        }}
        noResultsElement={this.noResults()}
      />
    );
  }
}
